function randomChoice(values) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var random = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Math.random;
  var _options$size = options.size,
      size = _options$size === void 0 ? 1 : _options$size,
      _options$replace = options.replace,
      replace = _options$replace === void 0 ? false : _options$replace;
  var valuesArr;

  if (typeof values === 'number') {
    valuesArr = getArray(values);
  } else {
    valuesArr = values.slice();
  }

  if (replace === false && size > valuesArr.length) {
    throw new Error('size option is too large');
  }

  var result = [];

  for (var i = 0; i < size; i++) {
    var index = randomIndex(valuesArr.length, random);
    result.push(valuesArr[index]);

    if (!replace) {
      valuesArr.splice(index, 1);
    }
  }

  return result;
}

function getArray(n) {
  var arr = [];

  for (var i = 0; i < n; i++) {
    arr.push(i);
  }

  return arr;
}

function randomIndex(n, random) {
  return Math.floor(random() * n);
}

export default randomChoice;